import { ShieldAlert } from "lucide-react";
import { Card, CardContent } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { useNavigate } from "react-router-dom";

export default function AccessDenied() {
  const nav = useNavigate();
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center">
          <ShieldAlert className="w-16 h-16 mx-auto mb-4 text-muted-foreground" />
          <h2 className="text-xl font-light mb-2" style={{ fontFamily: 'var(--font-sans)' }}>
            Access Restricted
          </h2>
          <p className="text-muted-foreground mb-6">
            The Executive Command Center is only available to Admin and COO roles.
          </p>
          <Button onClick={() => nav("/")} className="rounded-full">
            Return to Dashboard
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
